import { render } from "./IdentiteCoureur.vue?vue&type=template&id=521af977&scoped=true"
import script from "./IdentiteCoureur.vue?vue&type=script&lang=js"
export * from "./IdentiteCoureur.vue?vue&type=script&lang=js"

import "./IdentiteCoureur.vue?vue&type=style&index=0&id=521af977&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521af977"]])

export default __exports__